module.exports = __webpack_public_path__ + "media/images/icons/login_notification_arrow-f1bfb344cf1c11fa1ba28401ddaf6bc5.svg";